/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "@material-ui/core";
import useStore from "context";
import { PricingInformation } from "./pricing-information/index";
import { PLAN_ID } from "Constants";
import * as Api from "service";
import { useTranslation } from "localization/translation";
import { getQueryParam } from "helpers/getQueryParam";
import { ClipLoader } from "react-spinners";
import PlanInfo from "components/plan-info";
import { FeaturesInformation } from "./features-information";
import {
  CreateChildPlanModal,
  PlanInfoModal,
  PlanPriceModal,
  PlanAddFeatureModal,
} from "components/modals/planModal";

export default function PlanDetails() {
  const location = useLocation();
  const history = useHistory();
  const translation = useTranslation();

  const [planId, setPlanId] = useState(null);
  const [planDetails, setPlanDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingFeatures, setLoadingFeatures] = useState(false);
  const [isOpenEditPlanInfoModal, setIsOpenEditPlanInfoModal] = useState(false);
  const [isOpenEditPlanPriceModal, setIsOpenEditPlanPriceModal] = useState(false);
  const [isOpenAddFeatureModal, setIsOpenAddFeatureModal] = useState(false);
  const [planInfoData, setPlanInfoData] = useState({});
  const [planInfoModalData, setPlanInfoModalData] = useState({});
  const [priceData, setPriceData] = useState([]);
  const [priceModalData, setPriceModalData] = useState({});
  const [planFeatureData, setPlanFeatureData] = useState([]);
  const [features, setFeatures] = useState([]);
  const [planMissingFeatures, setPlanMissingFeatures] = useState([]);
  const [featureModalData, setFeatureModalData] = useState({});
  const [addFeatureSelectedId, setAddFeatureSelectedId] = useState(null);
  const [loadingUpdatePlanInfo, setLoadingUpdatePlanInfo] = useState(false);
  const [loadingUpdatePlanPrice, setLoadingUpdatePlanPrice] = useState(false);
  const [loadingAddPlanFeature, setLoadingAddPlanFeature] = useState(false);
  const [loadingChangeStatus, setLoadingChangeStatus] = useState(false);
  const [loadingChangeFeatureStatus, setLoadingChangeFeatureStatus] = useState(false);
  const [isEditPlanFeature, setIsEditPlanFeature] = useState(false);
  const [addFeatureForPlanErrors, setAddFeatureForPlanErrors] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [isOpenCreateChildModal, setIsOpenCreateChildModal] = useState(false);
  const [loadingCreateChild, setLoadingCreateChild] = useState(false);
  const [createChildError, setCreateChildError] = useState("");

  const { setRemove } = useStore();

  const paramsPlanId = getQueryParam(location, PLAN_ID);

  const routePlanDetails = (id) => {
    const queryParams = new URLSearchParams({ planId: id });
    history.push({
      pathname: location.pathname,
      search: queryParams.toString(),
    });
  };

  const openCreateChildModal = () => {
    setCreateChildError("");
    setIsOpenCreateChildModal(true);
  };

  const closeCreateChildModal = () => {
    if (!loadingCreateChild) {
      setIsOpenCreateChildModal(false);
      setCreateChildError("");
    }
  };

  const handleCreateChildPlan = async (data) => {
    setLoadingCreateChild(true);
    setCreateChildError("");
    try {
      const response = await Api.main.createChildPlan(planDetails.id, data);
      setIsOpenCreateChildModal(false);
      routePlanDetails(response.data.id);
    } catch (err) {
      setCreateChildError(err?.message || "Unable to create Lite plan");
    } finally {
      setLoadingCreateChild(false);
    }
  };

  const openPlanInfoModal = () => {
    setPlanInfoModalData({...planInfoData});
    setIsOpenEditPlanInfoModal(true);
  }
  const closePlanInfoModal = () => {
    setPlanInfoModalData({});
    setIsOpenEditPlanInfoModal(false);
  }
  const openPlanPriceModal = (id) => {
    const price = priceData.find(price => price.id === id);
    setPriceModalData({...price});
    setIsOpenEditPlanPriceModal(true);
  }
  const closePlanPriceModal = () => {
    setPriceModalData({});
    setIsOpenEditPlanPriceModal(false);
  }
  const openPlanAddFeatureModal = () => {
    setFeatureModalData({});
    setIsOpenAddFeatureModal(true);
    setAddFeatureForPlanErrors(null);
  }
  const closePlanAddFeatureModal = () => {
    setFeatureModalData({});
    setIsOpenAddFeatureModal(false);
  }

  const openPlanFeatureModal = (id, isEdit) => {
    if(isEdit) {
      const planFeature = planFeatureData.find(feature => feature.id === id);
      setFeatureModalData({...planFeature});
      setIsEditPlanFeature(true);
    } else {
      setFeatureModalData({
        name_hy: "",
        name_en: "",
        name_ru: "",
      });
      setIsEditPlanFeature(false);
    }
  }

  const handleChangePlanInfoData = (field, value) => {
    setPlanInfoModalData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleUpdatePlanInfoAction = (e) => {
    e.preventDefault();
    setLoadingUpdatePlanInfo(true)
    const updateData = {
      name_en: planInfoModalData.name_en,
      name_hy: planInfoModalData.name_hy,
      name_ru: planInfoModalData.name_ru,
      unlimited_items: planInfoModalData.unlimited_items,
      max_inventory_items: planInfoModalData.max_inventory_items,
      max_inventory_items_ml: planInfoModalData.max_inventory_items_ml,
      max_inventory_items_kg_pc: planInfoModalData.max_inventory_items_kg_pc,
      trial_period_days: planInfoModalData.trial_period_days,
    }
    Api.main
      .updatePlan(planInfoData.id, updateData)
      .then((res) => {
        fetchPlanDetails(planInfoData.id);
        setIsOpenEditPlanInfoModal(false);
      })
      .finally(() => {
        setLoadingUpdatePlanInfo(false)
      });
  }

  const handleStatusChange = (e) => {    
    e.preventDefault();
    setLoadingChangeStatus(true)
    Api.main
      .updatePlanStatus(planInfoData.id, { active: !planInfoData.active })
      .then((res) => {
        fetchPlanDetails(planInfoData.id);
      })
      .finally(() => {
        setLoadingChangeStatus(false)
      });
  }

  const handleUpdatePlanPriceAction = (e) => {
    e.preventDefault();
    setLoadingUpdatePlanPrice(true)
    Api.main
      .updatePlanPrice(planInfoData.id, priceModalData.id, priceModalData)
      .then((res) => {
        setIsOpenEditPlanPriceModal(false);
        fetchPlanDetails(planInfoData.id);
      })
      .finally(() => {
        setLoadingUpdatePlanPrice(false)
      });
  }

  const handleChangePlanPriceData = (field, value) => {
    setPriceModalData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddPlanFeatureAction = (e) => {
    e.preventDefault();
    setLoadingAddPlanFeature(true);
    setAddFeatureForPlanErrors(null);

    Api.main
      .addFeatureForPlan(planInfoData.id, { feature_id: addFeatureSelectedId })
      .then((res) => {
        fetchPlanDetails(planInfoData.id);
        setAddFeatureSelectedId(null);
        setAddFeatureForPlanErrors(null);
        setIsOpenAddFeatureModal(false);
      })
      .catch((err) => {
        setAddFeatureForPlanErrors({ feature: err.message })
      })
      .finally(() => {
        setLoadingAddPlanFeature(false)
      });
  }
  const handleAddFeatureChange = (id) => {
    if(id) {
      setAddFeatureSelectedId(id);
      setAddFeatureForPlanErrors(null);
    }
  }

  const deletePlanFeature = (featureId) => {    
    setRemove(() => () =>
      Api.main
        .deletePlanFeature(planInfoData.id, featureId)
        .then(() => {
          fetchPlanDetails(planInfoData.id);
        })
        .catch((err) => {
          setAddFeatureForPlanErrors({ feature: err.message })
        })    
    );
  }

  const handleActionFeatureStatusChange = (featureId) => {
    setLoadingChangeFeatureStatus(true)
    Api.main
      .updatePlanFeatureIncludes(planInfoData.id, featureId)
      .then((res) => {
        fetchPlanDetails(planInfoData.id);
      })
      .finally(() => {
        setLoadingChangeFeatureStatus(false)
      });
  }

  const handleReorderPlanFeatures = () => {
    const featureIds = planFeatureData.map((feature) => feature.id);
    Api.main
      .reorderPlanFeatures(planInfoData.id, featureIds)
      .then(() => fetchPlanDetails(planInfoData.id))
      .catch(() => fetchPlanDetails(planInfoData.id));
  };

  const fetchPlanDetails = async (id) => {
    setLoading(true);
    const { data } = await Api.main.getPlanDetails(id);
    const infoData = {
      id: data?.id,
      name_hy: data?.name_hy || '',
      name_en: data?.name_en || '',
      name_ru: data?.name_ru || '',
      active: data?.active || '',
      trial_period_days: data?.settings?.trial_period_days || 0,
      max_inventory_items: data?.settings?.max_inventory_items || 0,
      max_inventory_items_ml: data?.settings?.max_inventory_items_ml || 0,
      max_inventory_items_kg_pc: data?.settings?.max_inventory_items_kg_pc || 0,
      unlimited_items: data?.settings?.unlimited_items || false,
    }
    setPlanInfoData(infoData);
    setPriceData(data?.prices || {});
    setPlanFeatureData(data?.features || {});
    setPlanDetails(data);
    setLoading(false);
  };

  const fetchFeatures = async () => {
    setLoadingFeatures(true);
    try {
      const [{ data: featureData }, { data: planData }] = await Promise.all([
        Api.main.getFeatures(),
        Api.main.getPlans(),
      ]);
      setFeatures(featureData);
      setCurrencies(planData?.currencies || []);
    } finally {
      setLoadingFeatures(false);
    }
  };

  useEffect(() => {
    if (features && planFeatureData) {
      const missingFeatures = features.filter(
        f => !planFeatureData.some(p => p.id === f.id)
      );
      setPlanMissingFeatures(missingFeatures);
    }
  }, [features, planFeatureData]);

  useEffect(() => {
    if (location) {
      setPlanId(paramsPlanId);
    }
  }, [location, paramsPlanId]);

  useEffect(() => {
    if (planId) {
      fetchPlanDetails(planId);
      fetchFeatures();
    }
  }, [planId]);

  return (loading || loadingFeatures) ? (
    <div className="d-flex align-items-center flex-column px-4">
      <ClipLoader color={"#3c44b1"} loading={true} />
    </div>
  ) : (
    <>
      <div className="d-flex justify-content-between align-items-center px-4 pb-3">
        <h5 className="mb-0">
          {planDetails?.variant_type === "lite"
            ? translation.light_plan
            : translation.full_plan}
        </h5>
        {planDetails?.variant_type === "full" && !planDetails?.has_child && (
          <Button
            color="secondary"
            variant="contained"
            onClick={openCreateChildModal}
          >
            {translation.create_light_plan}
          </Button>
        )}
        {planDetails?.variant_type === "full" && planDetails?.child_plan && (
          <Button
            color="primary"
            variant="contained"
            onClick={() => routePlanDetails(planDetails.child_plan.id)}
          >
            {translation.open_light_plan}
          </Button>
        )}
        {planDetails?.variant_type === "lite" &&
          planDetails?.parent_plan_id && (
            <Button
              color="primary"
              variant="contained"
              onClick={() => routePlanDetails(planDetails.parent_plan_id)}
            >
              {translation.open_full_plan}
            </Button>
          )}
      </div>
      <PlanInfo
        name_hy={planDetails?.name_hy}
        name_en={planDetails?.name_en}
        name_ru={planDetails?.name_ru}
        active={planDetails?.active}
        trial_period_days={planDetails?.settings?.trial_period_days}
        max_inventory_items={planDetails?.settings?.max_inventory_items}
        max_inventory_items_ml={planDetails?.settings?.max_inventory_items_ml}
        max_inventory_items_kg_pc={planDetails?.settings?.max_inventory_items_kg_pc}
        unlimited_items={planDetails?.settings?.unlimited_items}
        actionHandler={openPlanInfoModal}
        actionStatusChange={handleStatusChange}
        loadingChangeStatus={loadingChangeStatus}
      />
      <div className="w-100 py-4"></div>
      <PricingInformation
        prices={planDetails?.prices}
        actionHandler={openPlanPriceModal}
      />
      <FeaturesInformation
        features={planDetails?.features}
        editHandler={(id) => {
          openPlanFeatureModal(id, true);
        }}
        deleteHandler={deletePlanFeature}
        handlerCreateFeature={() => {
          openPlanFeatureModal(null, false);
        }}
        showSecondButton={planMissingFeatures?.length > 0}
        secondButtonText={translation.add}
        handlerSecondButton={openPlanAddFeatureModal}
        actionFeatureStatusChange={handleActionFeatureStatusChange}
        loadingChangeFeatureStatus={loadingChangeFeatureStatus}
        showActiveButton
        reorderEnabled={planFeatureData.length > 1}
        setFeatures={setPlanFeatureData}
        onReorder={handleReorderPlanFeatures}
      />
      {
        !!isOpenEditPlanInfoModal && (
          <PlanInfoModal
            isOpen={isOpenEditPlanInfoModal}
            close={closePlanInfoModal}
            accept={handleUpdatePlanInfoAction}
            title={translation.edit_plan}
            loading={loadingUpdatePlanInfo}
            handleChangeData={handleChangePlanInfoData}
            planInfoData={planInfoModalData}
          />
        )
      }
      {
        !!isOpenEditPlanPriceModal && (
          <PlanPriceModal
            isOpen={isOpenEditPlanPriceModal}
            close={closePlanPriceModal}
            accept={handleUpdatePlanPriceAction}
            title={translation.edit_plan_price}
            loading={loadingUpdatePlanPrice}
            handleChangeData={handleChangePlanPriceData}
            priceData={priceModalData}
          />
        )
      }
      {
        !!isOpenAddFeatureModal && (
          <PlanAddFeatureModal
            isOpen={isOpenAddFeatureModal}
            close={closePlanAddFeatureModal}
            accept={(e) => {
              e.preventDefault();
              handleAddPlanFeatureAction(e)
            }}
            title={translation.add_feature}
            loading={loadingAddPlanFeature}
            handleFeatureChange={handleAddFeatureChange}
            selectedFeatureId={addFeatureSelectedId}
            features={planMissingFeatures}
            errors={addFeatureForPlanErrors}
          />
        )
      }
      {!!isOpenCreateChildModal && (
        <CreateChildPlanModal
          isOpen={isOpenCreateChildModal}
          close={closeCreateChildModal}
          accept={handleCreateChildPlan}
          loading={loadingCreateChild}
          parentPlan={planDetails}
          currencies={currencies}
          error={createChildError}
        />
      )}
    </>
  );
}
